import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { InputGroup, Input, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import { searchBlog } from 'Redux/ducks/blog';

const messages = defineMessages({
  placeholder: {
    id: 'blog.search.placeholder',
    defaultMessage: 'Search The Fanatical Blog',
  },
});

const onKeyPress = (e) => {
  if (e.keyCode === 13) {
    searchBlog(e.target.value);
  }
};

const onButtonClick = (searchTerm) => {
  searchBlog(searchTerm);
};

const BlogSearch = ({ intl, value }) => {
  const { formatMessage } = intl;

  const [searchTerm, setSearchTerm] = useState(value);

  useEffect(() => {
    setSearchTerm(value);
  }, [value]);

  return (
    <div className="blog-search-container container">
      <InputGroup>
        <Input
          aria-label="blog-search"
          type="text"
          value={searchTerm}
          enterKeyHint="search"
          placeholder={formatMessage(messages.placeholder)}
          onChange={e => setSearchTerm(e.target.value)}
          onKeyDown={e => onKeyPress(e)}
        />
        <div className="input-group-append">
          <Button color="primary" className="d-flex align-items-center" onClick={() => onButtonClick(searchTerm)}>
            <FontAwesomeIcon icon={faMagnifyingGlass} title="Search" />
          </Button>
        </div>
      </InputGroup>
    </div>
  );
};

BlogSearch.propTypes = {
  value: PropTypes.string,
};

BlogSearch.defaultProps = {
  value: '',
};

export default injectIntl(BlogSearch);
